module.exports = __webpack_public_path__ + "static/media/BebasNeueBold.1e99b044.ttf";